<template>
  <div>
    <p>
      {{
      $t($i18nLabelsHelper(organizationType, 'goals.engage_review')) }}
    </p>
    <el-form :model="goals">
      <el-row type="flex" justify="space-between">
        <el-col :md="11" :xs="24" class="practice">
          <el-card class="box-card" shadow="never">
            <div class="card-number">
              <span><img src="@/assets/images/task-list.svg" /></span>
            </div>
            <div class="card-content">
              <div class="description">
                <div class="input-wrapper">
                  {{ $t('classes.create_class_flow.class_created.goals_section.practice_at_least') }}
                  <elsa-input
                    v-model="goals.daysPractice"
                    type="number"
                    @change.native="$emit('goal-updated')"
                    :min="1"
                    :max="7"
                    :readonly="readOnly"
                  />
                  {{ $t('classes.create_class_flow.class_created.goals_section.days_week') }}
                </div>
                <p>{{ $t('classes.create_class_flow.class_created.goals_section.keep_them_engaged') }}</p>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :md="11" :xs="24" class="practice">
          <el-card class="box-card" shadow="never">
            <div class="card-number">
              <span><img src="@/assets/images/clock.svg" /></span>
            </div>
            <div class="card-content">
              <div class="description">
                <div class="input-wrapper">
                  {{ $t('classes.create_class_flow.class_created.goals_section.practice') }}
                  <elsa-input
                    class="minutes-practice"
                    v-model="goals.minutesPractice"
                    type="number"
                    @change.native="$emit('goal-updated')"
                    :min="1"
                    :max="1000"
                    :readonly="readOnly"
                  />
                  {{ $t('classes.create_class_flow.class_created.goals_section.minutes_day') }}
                </div>
                <p>{{ $t('classes.create_class_flow.class_created.goals_section.studies_review') }}</p>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :md="11" :xs="24" class="practice">
          <el-card class="box-card" shadow="never">
            <div class="card-content">
              <div class="description">
                <span class="assessment-test-title">{{ $t('classes.create_class_flow.class_created.goals_section.take_assessment_test') }}</span>
                <p>{{  $t($i18nLabelsHelper(organizationType, 'create_group_flow.group_created.goals_section.assessment_test_desc'))  }}</p>
                <div class="input-wrapper-assessment">
                  <span class="first-assessment">
                    {{ $t('classes.create_class_flow.class_created.goals_section.first_assessment_test') }}
                    <el-date-picker
                      v-model="goals.engagementFirstDate"
                      type="date"
                      @change.native="$emit('goal-updated')"
                      :picker-options="pickerOptions"
                      :placeholder="$t('classes.create_class_flow.class_created.goals_section.pick_a_day')">
                    </el-date-picker>
                  </span>
                  <!-- <span>
                    {{ $t('classes.create_class_flow.class_created.goals_section.second_assessment_test') }}
                    <el-date-picker
                      v-model="goals.engagementSecondDate"
                      type="date"
                      @change.native="$emit('goal-updated')"
                      :picker-options="pickerOptions"
                      placeholder="Pick a day">
                    </el-date-picker>
                  </span> -->
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :md="11" :xs="24" class="practice">
          <el-card class="box-card" hidden shadow="never">
            <div class="card-content">
              <div class="description">
                <span class="assessment-test-title">{{ $t('classes.create_class_flow.class_created.goals_section.send_reminders') }}</span>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ElsaInput from "@/components/common/Input";
import { isToday, isFuture } from 'date-fns'
export default {
  components: {
    ElsaInput
  },
  props: {
    goals: {
      type: Object,
      default: () => ({})
    },
    organizationType: {},
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const date = new Date(time)
          return !(isFuture(date) || isToday(date))
        }
      }
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin: 0;
}

.practice {
  display: flex;
  align-items: center;
  margin-top: 24px;
  .input-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: $black;
    .elsa-input {
      width: 64px;
      margin: 0 8px;

      &.minutes-practice {
        width: 58px;
      }
      &::v-deep .el-input .el-input__inner {
        height: 40px;
        opacity: 1;
        color: #478DFF;
        font-weight: 600;
        font-size: 20px;
      }
    }
    
  }
  .input-wrapper-assessment {
    font-size: 16px;
    font-weight: 300;
    display: block;
    line-height: 24px;
    color: $black;
    margin-top: 10px;
    .el-date-editor.el-input {
      width: 140px;
      float: right;
      margin-top: -8px;
    }
    span.first-assessment {
        margin-bottom: 25px;
        display: block;
    }
  }
  .description {
    p {
      margin-top: 5px;
      font-size: 16px;
      line-height: 24px;
      opacity: 0.7;
    }
    .assessment-test-title {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      color: $black;
      opacity: 1;
    }
  }
  .box-card {
      border: 1px solid #e6e6e6;
      box-sizing: border-box;
      border-radius: 16px;
      // margin-bottom: 24px;
      height: 214px;
      width:100%;
      ::v-deep .el-card__body {
        align-items: flex-start;
        .card-number {
            margin-bottom: 8px;
        }
        .card-content {
          flex: 1 0;

          h2 {
            font-size: 24px;
            line-height: 36px;
            color: #121131;
          }

          p {
            font-size: 16px;
            line-height: 24px;
            color: #121131;
          }

          button {
            float: right;
          }
        }
      }
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: start;
    .description {
      margin-top: 15px;
      margin-left: 0;
    }
    .input-wrapper {
      flex-direction: column;
      align-items: start;
      .elsa-input {
        margin: 5px 0;
      }
    }
  }
}
</style>
